import { TrackingPageType } from '@shopee-user/business-customization-types';

export const PageType: TrackingPageType = {
  LoginPage: 'spx_login',
  OTPDialogPopup: 'spx_verification_alert_popup',
  OTPEnterVerificationPage: 'enter_verification_code',
  OTPSelectVerificationMethodPage: 'select_verification_method',
  ResetPasswordPage: 'forgot_password',
  SetNewPasswordPage: 'new_password',
  VerifyCurrentPasswordPage: '',
  MyAccountPage: '',
  MyStaffAccountListPage: '',
  StaffAccountDetailsPage: '',
  MerchantAccountSettingPage: '',
  EnterNewPhonePage: 'new_phone_number',
  EnterNewEmailPage: 'new_email',
  ChangePhonePage: '',
  ChangeEmailPage: '',
  AccountUpdateMethodSelectionPage: '',
  AccountUpdateOverviewPage: 'link_account_to_shopee',
  AccountUpdateSuccessPage: 'account_linked_successfully',
  AccountBindAccountBindingPage: 'confirm_shopee_account',
  AccountBindReclaimFailurePage: 'reclaim_failed',
  AccountBindCreateAccountPage: 'create_shopee_account',
  AccountBindSetPasswordPage: 'set_shopee_password',
  SignupPage: 'spx_sign_up',
  SignupPhoneAlreadyRegisteredPage: 'number_already_registered',
  SignupEmailAlreadyRegisteredPage: 'email_already_registered',
  SignupSetPasswordPage: 'set_tob_account_password',
  SignupSuccessPage: 'tob_account_created',
  BiometricPromptPage: '',
  ReloginBiometricsPage: '',
  ReloginQuickLoginPage: 'reloginquickloginpage',
  ReloginPasswordPage: 'reloginpasswordpage',
  WhatsappAuthLink: '',
  OneCredentialDelinkInitPage: 'delink_oc_info_page',
  OneCredentialDelinkSetupTobAccountPage: 'delink_oc_setup_account_credential',
  OneCredentialDelinkSetupPasswordPage: 'delink_oc_setup_account_password',
  OneCredentialDelinkSuccessPage: 'delink_oc_success',
  OneCredentialDelinkErrorPage: 'delink_oc_failure',
  ThirdPartyAccountLinkagePage: 'spx_third_party_account_linkage',
  ThirdPartyServiceBindingWithPhonePage: 'spx_third_party_login_bind_phone',
  ThirdPartyServiceBindingWithPhoneAlreadyRegisteredPage:
    'spx_third_party_login_phone_already_registered',
  ThirdPartyServiceSignupWithPhoneSuccessPage:
    'spx_third_party_signup_phone_success_prompt',
  ThirdPartyServiceSignupWithPhoneFailedPage:
    'spx_third_party_signup_phone_fail_prompt',
  ThirdPartyServiceLoginWithPhoneSuccessPage:
    'spx_third_party_login_phone_success_prompt',
  ThirdPartyServiceLoginWithPhoneFailedPage:
    'spx_third_party_login_phone_fail_prompt',
  QuickLoginPromptPage: 'quickloginpromptpage',
};
